import PropTypes from "prop-types";
import { memo, useContext } from "react";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import LineClampViewMore from "app/pages/.shared/LineClampViewMore/LineClampViewMore";
import { RESOLUTION } from "app/pages/.shared/responsive/responsiveReducer";
import AppGlobalsContext from "app/AppGlobalsContext";
import { htmlSanitize } from "app/utils/sanitize";
import Collapse from "rc-collapse";
import RelativeLink from "app/pages/.shared/RelativeLink";

const BlockSeo = ({ blockTextTitle, blockTextDescription, blockLinkTitle, blockLinks }) => {
	const { resolution } = useContext(AppGlobalsContext);

	const isMobile = resolution === RESOLUTION.SMALL || resolution === RESOLUTION.MEDIUM;
	return (
		<div className="block-seo" data-testid="block-seo">
			<div className="block-seo__container">
				<div className="block-seo__section">
					{blockTextTitle && (
						<Typography
							variant={TYPOGRAPHY_VARIANTS.XL3}
							isBold
							className="block-seo__title"
							component="div"
							data-testid="block-seo-title"
						>
							<span
								dangerouslySetInnerHTML={{
									__html: htmlSanitize(blockTextTitle),
								}}
							/>
						</Typography>
					)}
					{blockTextDescription && (
						<LineClampViewMore
							enableShowMore={true}
							lineCount={isMobile ? 4 : 2}
							text={
								<span
									dangerouslySetInnerHTML={{
										__html: htmlSanitize(blockTextDescription),
									}}
								/>
							}
						/>
					)}
				</div>
				{blockLinks?.length > 0 && (
					<div className="block-seo__section" data-testid="block-links">
						<Collapse
							defaultActiveKey={["0"]}
							expandIcon={({ isActive }) => {
								return (
									<i
										style={{
											transition: "transform .2s ease",
											transform: `rotate(${isActive ? 0 : 180}deg)`,
										}}
										className="icon icon--seo-expand"
									/>
								);
							}}
						>
							<Collapse.Panel
								headerClass="block-seo__collapse-header"
								header={
									<Typography
										variant={TYPOGRAPHY_VARIANTS.XL3}
										isBold
										className="block-seo__title block-seo__links-title"
										component="div"
										data-testid="block-seo-links-title"
									>
										<span
											dangerouslySetInnerHTML={{
												__html: htmlSanitize(blockLinkTitle),
											}}
										/>
									</Typography>
								}
							>
								<div
									className={`block-seo__links block-seo__links-${
										blockLinks?.length > 4 ? 4 : blockLinks?.length
									}-rows`}
								>
									{blockLinks.map(link => (
										<RelativeLink
											key={link?.url}
											rel="noopener noreferrer"
											target="_blank"
											className="block-seo__link"
											to={{ pathname: link?.url }}
											data-testid="block-seo-link"
										>
											{link?.title}
											<i className="icon icon--seo-link block-seo__link-icon" />
										</RelativeLink>
									))}
								</div>
							</Collapse.Panel>
						</Collapse>
					</div>
				)}
			</div>
		</div>
	);
};

BlockSeo.propTypes = {
	blockTextTitle: PropTypes.string,
	blockTextDescription: PropTypes.string,
	blockLinkTitle: PropTypes.string,
	blockLinks: PropTypes.array,
};

export default memo(BlockSeo);
